var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Modifier from 'ember-modifier';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import { registerDestructor } from '@ember/destroyable';
function cleanup(instance) {
  let {
    el,
    scheduleResize
  } = instance;
  el.removeEventListener('input', scheduleResize);
}
let AutoresizeModifier = (_class = class AutoresizeModifier extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "listener", null);
  }
  resize() {
    let {
      el: element
    } = this;
    let dimension = this.named.mode ?? 'height';
    let previousWrap = element.style.whiteSpace;
    if (dimension === 'width') {
      // disable default wrapping
      element.style.whiteSpace = 'pre';
    }
    let capitalizeDimension = dimension[0].toUpperCase() + dimension.slice(1);

    // height / width must be calculated independently from height / width previously enforced
    element.style[dimension] = 'auto';
    let isBorderBox = window.getComputedStyle(element).boxSizing === 'border-box';
    let requiredDimension = element[`scroll${capitalizeDimension}`];
    if (isBorderBox) {
      // borders must be added on top of scrollHeight / scrollWidth if box-sizing is border-box
      let borderDimension = element[`offset${capitalizeDimension}`] - element[`client${capitalizeDimension}`];
      requiredDimension += borderDimension;
    }
    element.style[dimension] = `${requiredDimension}px`;
    element.style.whiteSpace = previousWrap;
  }
  scheduleResize() {
    // Relying on Ember's runloop directly as we don't want to pull in another dependency.
    // eslint-disable-next-line ember/no-runloop
    scheduleOnce('afterRender', this, 'resize');
  }
  modify(element, [value], named) {
    this.el = element;
    this.named = named;
    this.value = value;
    if (this.listener === null) {
      this.listener = this.el.addEventListener('input', this.scheduleResize);
    }
    this.scheduleResize();
    registerDestructor(this, cleanup);
  }
}, _applyDecoratedDescriptor(_class.prototype, "resize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scheduleResize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "scheduleResize"), _class.prototype), _class);
export { AutoresizeModifier as default };